
import apiClient from '../config/axios';
import { ENDPOINTS } from '../constants/endpoints';

export const typeArticleService = {
  // Get type articles with pagination and filters
  getTypeArticles: async (pageSize = 10, page = 1, filters = {}) => {
    try {
      // Build the URL with path parameters for pagination
      const url = `${ENDPOINTS.TYPE_ARTICLE}/${pageSize}/${page}`;
      
      // Build query parameters for filters only
      const params = {};

      // Add filters if they exist
      if (filters.searchTerms) {
        params.SearchTerms = filters.searchTerms;
      }
      if (filters.familleId) {
        params.FamilleId = filters.familleId;
      }

      const response = await apiClient.get(url, {
        params: params
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching type articles:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des types d\'articles',
        error: error.response?.data,
      };
    }
  },


  // Get type article by ID
  getTypeArticleById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.TYPE_ARTICLE}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get type article by ID error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement du type d\'article',
        error: error.response?.data,
      };
    }
  },

  // Create new type article
  createTypeArticle: async (formData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.TYPE_ARTICLE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création du type d\'article',
        error: error.response?.data,
      };
    }
  },

  getAllTypeArticlesWithFamille: async () => {
    try {
      const response = await apiClient.get(ENDPOINTS.TYPE_ARTICLE);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors du chargement des types d'article (flat)",
        error: error.response?.data,
      };
    }
  },

  // Update type article
  updateTypeArticle: async (id, formData) => {
    try {
      if (!formData.has('Id')) formData.append('Id', id);
      const response = await apiClient.put(ENDPOINTS.TYPE_ARTICLE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour du type d\'article',
        error: error.response?.data,
      };
    }
  },

  // Delete type article
  deleteTypeArticle: async (id) => {
    try {
      const response = await apiClient.delete(`${ENDPOINTS.TYPE_ARTICLE}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Delete type article error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression du type d\'article',
        error: error.response?.data,
      };
    }
  },
};

export default typeArticleService;